/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContactCreate } from '../models/ContactCreate';
import type { ContactDetails } from '../models/ContactDetails';
import type { ContactUpdate } from '../models/ContactUpdate';
import type { PagedItems } from '../models/PagedItems';
import type { PagingQuery } from '../models/PagingQuery';
import { request as __request } from '../core/request';

export class ContactsVService {

    /**
     * @param billingAccountId
     * @param requestBody
     * @returns PagedItems OK
     * @throws ApiError
     */
    public static async contactsVGetAll(
        billingAccountId: string,
        requestBody?: PagingQuery,
    ): Promise<PagedItems> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/billing_accounts/${billingAccountId}/contacts/get`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param billingAccountId
     * @param requestBody
     * @returns ContactDetails OK
     * @throws ApiError
     */
    public static async contactsVGetExport(
        billingAccountId: string,
        requestBody?: PagingQuery,
    ): Promise<ContactDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/billing_accounts/${billingAccountId}/contacts/export`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param billingAccountId
     * @param contactId
     * @param requestBody
     * @returns ContactDetails OK
     * @throws ApiError
     */
    public static async contactsVUpdateContact(
        billingAccountId: string,
        contactId: string,
        requestBody?: ContactUpdate,
    ): Promise<ContactDetails> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v2/billing_accounts/${billingAccountId}/contacts/${contactId}`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param billingAccountId
     * @param contactId
     * @returns ContactDetails OK
     * @throws ApiError
     */
    public static async contactsVGetById(
        billingAccountId: string,
        contactId: string,
    ): Promise<ContactDetails> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/billing_accounts/${billingAccountId}/contacts/${contactId}`,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param billingAccountId
     * @param contactId
     * @returns any No Content
     * @throws ApiError
     */
    public static async contactsVDelete(
        billingAccountId: string,
        contactId: string,
    ): Promise<any> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/v2/billing_accounts/${billingAccountId}/contacts/${contactId}`,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param billingAccountId
     * @param requestBody
     * @returns ContactDetails Created
     * @throws ApiError
     */
    public static async contactsVCreate(
        billingAccountId: string,
        requestBody?: ContactCreate,
    ): Promise<ContactDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/billing_accounts/${billingAccountId}/contacts`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

}